<template>
  <section class="text-center">    
    <div class="box-content">      
      <p>
        {{ $t('WAITING_FOR_GRAPH_AUTHENTICATION', { appHostName: teams.name }) }}  
      </p>

    </div>

  </section>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  computed: {    
  }
};
</script>
<style>
</style>

